import styled from '@emotion/styled'
import Breakpoint from '../../Breakpoint'

const AdminContainer = styled.div`
    width: 100%;
    padding: 38px 24px 24px calc(15% + 24px);
    box-sizing: border-box;
    position: relative;
    margin-left: 0;
    transition: padding 0.3s ease-in-out;

    @media (max-width: ${Breakpoint.TABLET_L}) {
        padding: 16px;
        top: 42px;
    }

    @media (max-width: ${Breakpoint.PHONE}) {
        width: 100%;
    }
`

export default AdminContainer
